<script setup>
import { onMounted } from "vue";
const BrowserLogger = require("@arms/js-sdk");
onMounted(() => {
  let scene = "";
  switch (process.env.DEFINE_NODE_ENV) {
    case "prod":
      scene = "prod";
      break;
    default:
      scene = "local";
      break;
  }
  BrowserLogger.singleton({
    pid: "jn9dyban6b@eba3fe3332f9437",
    appType: "web",
    imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
    sendResource: true,
    enableLinkTrace: true,
    behavior: true,
    useFmp: true,
    enableSPA: true,
    environment: scene,
  });
});
</script>

<style lang="scss">
/*每个页面公共css */
.uni-easyinput ::v-deep .is-focused {
  border-color: #ffdd00 !important;
}
.uni-easyinput ::v-deep .is-focused .content-clear-icon::before {
  color: #ffdd00 !important ;
}
.uni-easyinput ::v-deep .is-focused .uni-easyinput__content-input {
  color: #030303 !important ;
}
</style>
